var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.889,
    height: 10.18,
    viewBox: "0 0 16.889 10.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:.75px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_29",
    "data-name": "Group 29",
    transform: "rotate(180 93.979 149.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_27",
    "data-name": "Group 27",
    transform: "translate(171.514 293.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_10",
    d: "M0 0L16.069 0.001",
    className: "prefix__cls-1",
    "data-name": "Line 10"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_23",
    d: "M176.014 289.279l-4.57 4.569 4.55 4.55",
    className: "prefix__cls-1",
    "data-name": "Path 23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9bd6ed804d9bcb4604e38c1f8abf8661.svg";
export { ForwardRef as ReactComponent };